export const getReferralLang = payload => {
  if (payload && payload.prefferedLanguage === 'french') {
    return 'fr-CA';
  }
  return 'en-US';
};
